var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBackMerah(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 30.74L20.74 30.74C26.2628 30.74 30.74 26.2629 30.74 20.74L30.74 10C30.74 4.47716 26.2628 5.72205e-06 20.74 5.72205e-06L9.99999 5.72205e-06C4.47714 5.72205e-06 -9.53674e-06 4.47716 -9.53674e-06 10L-9.53674e-06 20.74C-9.53674e-06 26.2629 4.47714 30.74 9.99999 30.74Z",
    fill: "#E3232A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.85 24.16L20.39 16.62C20.6538 16.354 20.8018 15.9946 20.8018 15.62C20.8018 15.2454 20.6538 14.886 20.39 14.62L12.39 6.61999C12.1241 6.35619 11.7646 6.20816 11.39 6.20816C11.0154 6.20816 10.656 6.35619 10.39 6.61999C10.1262 6.88596 9.97818 7.24539 9.97818 7.61999C9.97818 7.9946 10.1262 8.35403 10.39 8.61999L16.39 14.62C16.6538 14.886 16.8018 15.2454 16.8018 15.62C16.8018 15.9946 16.6538 16.354 16.39 16.62L10.88 22.13C10.6209 22.3984 10.4762 22.7569 10.4762 23.13C10.4762 23.5031 10.6209 23.8616 10.88 24.13C11.1431 24.3844 11.4932 24.5291 11.8591 24.5346C12.225 24.5402 12.5793 24.4063 12.85 24.16Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackMerah);
export default __webpack_public_path__ + "static/media/Icon_Back_Merah.63ea7ccb.svg";
export { ForwardRef as ReactComponent };